import React from 'react';
import FormItemText from "./FormItemText";

const FormItemEmail = props => {
    return <FormItemText maxLength={128} email {...props}/>
}
export default FormItemEmail;